// extracted by mini-css-extract-plugin
module.exports = {"overflow":"confirm_overflow__2_1m5","cancel":"confirm_cancel__2Mnhs","save":"confirm_save__yaQK9"};